<script setup lang="ts">
import { IconName } from "@/constants";
import IconComponent from "../IconComponent/IconComponent.vue";
import { PresetHelper } from "@/helpers/preset.helper";
import { computed } from "vue";
import AccordionComponent from "../AccordionComponent/AccordionComponent.vue";
import AccordionHeaderComponent from "../AccordionComponent/lib/AccordionHeaderComponent.vue";
import AccordionPanelComponent from "../AccordionComponent/lib/AccordionPanelComponent.vue";
import AccordionContentComponent from "../AccordionComponent/lib/AccordionContentComponent.vue";

export interface TaiErrorDisplayComponentProps {
  message: string;
  details?: Error | null; // Optional error object
  variant?: "small" | "large";
}

const { message, variant = "small" } =
  defineProps<TaiErrorDisplayComponentProps>();

const { applyPreset } = new PresetHelper({
  classMap: {
    tai__error_display_root: {
      layout: ["flex gap-2 justify-center items-center "],
      color: ["text-red-500"]
    },
    "tai__error_display_root--small": {
      layout: ["text-body-sm"]
    },
    "tai__error_display_root--large": {
      layout: ["text-body"]
    }
  },
  preset: {
    root: () => [
      "tai__error_display_root",
      {
        "tai__error_display_root--small": variant === "small",
        "tai__error_display_root--large": variant === "large"
      }
    ]
  }
});

const preset = computed(() => applyPreset({}));
</script>

<template>
  <div class="flex flex-col gap-4">
    <div :class="preset.root.class">
      <span class="text-xl">
        <IconComponent :name="IconName.CautionOutline" />
      </span>
      <p>{{ message }}</p>
    </div>
    <div v-if="details">
      <AccordionComponent>
        <AccordionPanelComponent value="1">
          <AccordionHeaderComponent>
            <span class="text-sm">Error details</span>
          </AccordionHeaderComponent>
          <AccordionContentComponent>
            <p class="error-details" v-html="details.message"></p>
          </AccordionContentComponent>
        </AccordionPanelComponent>
      </AccordionComponent>
    </div>
  </div>
</template>

<style>
@reference "../../assets/css/tailwind-reference.css";

.error-details {
  @apply text-left text-sm text-system-dark-grey;
}

.error-details a {
  @apply underline;
}
</style>
